const CapitalizeWords = (str: string) => {
	return str.replace(
		/(^|\s)(\S)/g,
		(_, space: string, char: string) => space + char.toUpperCase()
	);
};

export default CapitalizeWords;
